import moment from "moment"
const date=new Date();
export default {
    offerline:{
        default:true,
        method:0,
        way:1,
        startTime:moment(date).subtract(7, 'months').startOf('month').format('YYYY-MM'),
        endTime:moment(date).subtract(1, 'months').startOf('month').format('YYYY-MM')
    },
    powerout:{
        default:true,
        method:0,
        way:1,
        startTime:moment(date).subtract(7, 'months').startOf('month').format('YYYY-MM'),
        endTime:moment(date).subtract(1, 'months').startOf('month').format('YYYY-MM')
    },
    configure:{
        default:true,
        method:0,
        way:1,
        startTime:moment(date).subtract(7, 'months').startOf('month').format('YYYY-MM'),
        endTime:moment(date).subtract(1, 'months').startOf('month').format('YYYY-MM')
    }
}